



/* Custom code for product media slider START*/

function customNavigateGallery(direction, galleryId) {
  const gallery = document.getElementById(galleryId);
  const slides = gallery.querySelectorAll('.slider__slide');
  const thumbnails = document.querySelectorAll(`#Slider-Thumbnails-${galleryId.split('-')[1]} .thumbnail`);
  const activeSlide = gallery.querySelector('.is-active');
  const activeIndex = Array.from(slides).indexOf(activeSlide);

  // Calculate the next index
  let nextIndex = direction === 'next' ? activeIndex + 1 : activeIndex - 1;
  if (nextIndex < 0) nextIndex = slides.length - 1; // Wrap to last slide
  if (nextIndex >= slides.length) nextIndex = 0; // Wrap to first slide

  // Update active slide
  activeSlide.classList.remove('is-active');
  slides[nextIndex].classList.add('is-active');

  // Simulate a click on the corresponding thumbnail
  const currentThumbnail = document.querySelector('.thumbnail[aria-current]');
  if (currentThumbnail) {
    const parentElement = currentThumbnail.parentElement;
    let targetThumbnail;

    if (direction === 'next') {
      targetThumbnail = parentElement.nextElementSibling;
    } else {
      targetThumbnail = parentElement.previousElementSibling;
    }

    if (targetThumbnail) {
      const clickableElement = targetThumbnail.querySelector('button');
      if (clickableElement) {
        clickableElement.click();
      } else {
        console.warn('No clickable element found in the target thumbnail.');
      }
    } else {
      console.warn('No target thumbnail found in the desired direction.');
    }
  } else {
    console.warn('No thumbnail with aria-current found.');
  }

  // Optional: Dispatch slideChanged event
  gallery.dispatchEvent(
    new CustomEvent('slideChanged', {
      detail: { currentElement: slides[nextIndex] },
    })
  );
}


/* Custom code for product media slider END */




// Custom Code for Product price in product grids START
// Custom Code for Product price in product grids START
document.addEventListener("DOMContentLoaded", function () {
  // Helper function for formatting money
  function formatMoney(amount) {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 2, // Ensures two decimal places
    }).format(amount);
  }

  // Delay to ensure the grid is loaded
  setTimeout(() => {
    // Check if the grid exists
    const productGrid = document.querySelector('.boost-sd__product-list');
    if (productGrid) {
      console.log("Collection grid detected");

      // Find all product items
      const productItems = productGrid.querySelectorAll('.boost-sd__product-item');

      // Iterate through each product item
      productItems.forEach(product => {
        // Find the price element
        const priceElement = product.querySelector('.boost-sd__product-price .boost-sd__format-currency');
        const priceWrapper = product.querySelector('.boost-sd__product-price');
        const priceWrapperContainer = product.querySelector('.boost-sd__product-price-wrapper');

        if (priceElement) {
          // Get the original price as a number
          const priceText = priceElement.textContent.replace(/[^\d.]/g, ''); // Extract numeric value
          const price = parseFloat(priceText);

          // If the price is 0, hide the price container
          if (!price || price === 0) {
            priceWrapper.classList.add('hidden');
            return; // Skip further processing for this product
          }

          // Prepend "From:" span to the price element
          const fromSpan = document.createElement('span');
          fromSpan.textContent = 'From: ';
          priceWrapper.insertBefore(fromSpan, priceWrapper.firstChild);

          // Append "GBP (Excl. VAT)" span to the price wrapper container
          const exclVatSpan = document.createElement('span');
          exclVatSpan.textContent = ' GBP (Excl. VAT)';
          priceWrapper.appendChild(exclVatSpan);

          // Check if VAT-inclusive price already exists, if so, remove it before appending
          const existingVatPrice = product.querySelector('.price-item--incl-vat');
          if (existingVatPrice) existingVatPrice.remove();

          // Calculate VAT-inclusive price
          const vatRate = 0.2; // VAT rate
          const vatInclusivePrice = price * (1 + vatRate);

          // Create VAT price element
          const vatPriceElement = document.createElement('div');
          vatPriceElement.classList.add('price-item', 'price-item--incl-vat');
          vatPriceElement.style.opacity = '0.4'; // Style for opacity
          vatPriceElement.textContent = `From: ${formatMoney(vatInclusivePrice)} GBP (Incl. VAT)`;

          // Append the new VAT-inclusive price element
          priceWrapper.appendChild(vatPriceElement);
        }
      });
    } else {
      console.log("No collection grid found on this page.");
    }
  }, 4000); // Adjust delay as needed
});
// Custom Code for Product price in product grids END
// Custom Code for Product price in product grids END


// Custom code for Cart Prompt START
document.addEventListener("DOMContentLoaded", function () {
  // Check if the current page is the cart page by verifying the existence of <cart-items>
  const cartItemsElement = document.querySelector("cart-items");
  if (!cartItemsElement) {
    return; // Exit if <cart-items> does not exist
  }

  const cartData = window.wcp_data.wcp_cart;
  const requiredAddons = ["addon_accessories", "addon_handles"]; // Add-ons to check

  // Function to HTML-escape dynamic content
  function htmlEscape(str) {
    return str.replace(/&/g, "&amp;")
              .replace(/</g, "&lt;")
              .replace(/>/g, "&gt;")
              .replace(/"/g, "&quot;")
              .replace(/'/g, "&#39;");
  }

  // Function to clean the product title (remove variant info)
  function cleanProductTitle(title) {
    return title.split(" - ")[0]; // Remove everything after the first " - "
  }

  let addonIssues = [];

  cartData.items.forEach((item) => {
    if (
      item.original_item &&
      item.original_item.properties &&
      requiredAddons.some((addon) => addon in item.original_item.properties)
    ) {
      // Check for missing required add-ons
      requiredAddons.forEach((addon) => {
        if (
          !item.original_item.properties[addon] ||
          item.original_item.properties[addon].trim() === ""
        ) {
          addonIssues.push({
            product: htmlEscape(cleanProductTitle(item.original_item.title)),
            addon: htmlEscape(addon),
          });
        }
      });
    }
  });

  if (addonIssues.length > 0) {
    // Create the message div
    const messageDiv = document.createElement("div");
    messageDiv.classList.add("page-width"); // Add the .page-width class
    messageDiv.style.backgroundColor = "#f9f9f9";
    messageDiv.style.padding = "10px 20px";
    messageDiv.style.marginTop = "20px";
    messageDiv.style.marginBottom = "20px";
    messageDiv.style.border = "1px solid #ccc";
    messageDiv.style.borderRadius = "5px";

    // Add message content
    // const issueMessages = addonIssues.map(
    //   (issue) =>
    //     `It seems you haven’t selected a ${issue.addon.replace(
    //       "_",
    //       " "
    //     )} for ${issue.product}. Kindly review your cart to add additional items or proceed with checkout.`
    // );
    // messageDiv.innerHTML = `<p>${issueMessages.join("<br>")}</p>`;
    messageDiv.innerHTML = `Don’t forget to select a handle(s) or accessories to complete your pocket door system. <a href="/collections/accessories">Shop Accesories</a>`;

    // Append the message div after the <cart-items> element
    cartItemsElement.insertAdjacentElement("afterend", messageDiv);
  }
});

// Custom code for Cart Prompt END


// Code to add Accessories Note START
document.addEventListener("DOMContentLoaded", function () {
    var container = document.getElementById("infiniteoptions-container");
    if (container) {
        var note = document.createElement("small");
        note.textContent = "View details of the accessories in the description below.";
        container.parentNode.insertBefore(note, container.nextSibling);
    }
});
// Code to add Accessories Note END


// Code to scroll after add to cart START
document.addEventListener("DOMContentLoaded", function () {
    const addToCartButton = document.querySelector(".product-form__buttons button.product-form__submit");
    const productInfoWrapper = document.querySelector(".product .product__info-wrapper");
    const upsellBlock = document.querySelector(".upsell-theme-app-block-custom");

    if (addToCartButton && productInfoWrapper && upsellBlock) {
        addToCartButton.addEventListener("click", function () {
            setTimeout(() => {
                const targetPosition = upsellBlock.getBoundingClientRect().top + window.scrollY - 100;
                window.scrollTo({ top: targetPosition, behavior: "smooth" });
            }, 500); // 500ms delay
        });
    }
});
// To disable the opening of the cart popup, cgo to cart-notification.js and comment out "this.open()"
// Code to scroll after add to cart END
